/**
 * Construcción centralizada de rutas de la aplicación (DT-102).
 *
 * Por qué existe: la plantilla `/organization/${slug}/my-organization` estaba
 * duplicada literalmente en 8 ficheros, y las de `/admin/...` en 4 más. Un
 * cambio de segmento en el router obligaba a encontrarlos todos a mano.
 *
 * Todas las rutas son ABSOLUTAS a propósito. Con `useNavigate()`, `..` sube un
 * nivel de *ruta* (no de segmento de URL) y las rutas índice no aportan path:
 * saltar entre rutas hermanas con `..` resuelve a una ruta no declarada y cae
 * en el catch-all 404 (E147, ver common-errors.md).
 */

/** Rutas del área de organización (`/organization/:slug/...`). */
export const orgPaths = {
  /** Raíz de la organización. Útil como prefijo de rutas hijas. */
  root: (slug: string): string => `/organization/${slug}`,

  /** Página "Mi Organización" — destino canónico tras login y de los guards. */
  myOrganization: (slug: string): string => `/organization/${slug}/my-organization`,

  /** Detalle de una conexión (entidad `Connection` en el código). */
  connection: (slug: string, connectionId: string): string => `/organization/${slug}/connections/${connectionId}`,
} as const;

/** Rutas del panel SuperAdmin (`/admin/...`), que no llevan slug de organización. */
export const adminPaths = {
  /** Detalle de una organización en el panel SuperAdmin. Se direcciona por slug. */
  organization: (slug: string): string => `/admin/organizations/${slug}`,

  /** Detalle de una conexión desde el panel SuperAdmin, sin organización en el path. */
  connection: (connectionId: string): string => `/admin/connections/${connectionId}`,
} as const;

/** Deep links neutros: no llevan prefijo de rol ni slug, se resuelven en el cliente. */
export const deepLinkPaths = {
  /** Deep link neutro de una conexión: resuelve rol → ruta real (ConnectionRedirect). */
  connection: (connectionId: string): string => `/connections/${connectionId}`,
} as const;
